import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';
import MultiSelect from '@components/v2/MultiSelect';
import { BANK_APPLICATION_STATUS } from '@modules/opportunities/entities/bankApplication/const';
import { bankApplicationStatusMapper } from '@modules/opportunities/mappers/bankApplicationStatusMapper';
import { OPPORTUNITY_STATUS } from '@modules/opportunities/entities/opportunity/const';
import { BankApplicationStatus } from '@modules/opportunities/entities/bankApplication/bankApplication.entity';
import { CasesRoute } from '@modules/opportunities/presentation/routes';
import { STATUS_GROUPS } from '@modules/opportunities/presentation/pages/const';
import { StatusTag } from '@components/StatusTag';

const data = [
  OPPORTUNITY_STATUS.draft,
  BANK_APPLICATION_STATUS.bankSubmission,
  BANK_APPLICATION_STATUS.creditQueries,
  BANK_APPLICATION_STATUS.docsReview,
  BANK_APPLICATION_STATUS.salesQueries,
  BANK_APPLICATION_STATUS.salesSubmittedToCredit,
  BANK_APPLICATION_STATUS.preApproved,
  BANK_APPLICATION_STATUS.valuation,
  BANK_APPLICATION_STATUS.fol,
  BANK_APPLICATION_STATUS.folSigned,
  BANK_APPLICATION_STATUS.notProceeding,
  BANK_APPLICATION_STATUS.onHold,
  BANK_APPLICATION_STATUS.disbursed,
  BANK_APPLICATION_STATUS.finalDocs,
  BANK_APPLICATION_STATUS.propertyTransferred
].map(
  (item) => ({
    value: item,
    label: bankApplicationStatusMapper((item) as BankApplicationStatus).text,
    // eslint-disable-next-line react/no-unstable-nested-components
    node: () => (<StatusTag status={ item as BankApplicationStatus } />),
  })
);

const StatusFilter = () => {
  const { t } = useTranslation();
  const navigate = useNavigate({ from: CasesRoute.fullPath });
  const { status } = CasesRoute.useSearch();
  const filtersInUrl = status && status.length > 0
    ? status?.split('|').filter((_status) => !Object.values(STATUS_GROUPS).includes(_status))
    : [];

  const onApply = (filters: Array<string>) => {
    if (filters.length === filtersInUrl.length && filters.every((filter) => filtersInUrl.includes(filter))) {
      return;
    }

    navigate({
      search: ({ status: _status, ...prev }) => ({
        ...prev,
        ...(filters.length > 0 ? { status: filters.join('|') } : {}),
        page: 1,
      }),
    });
  };

  return (
    <MultiSelect
      label={ filtersInUrl.length > 0
        ? t('common.forms.activeItems', { items: filtersInUrl.length }) : t('common.forms.status.placeholder') }
      header={ t('common.forms.status.placeholder') }
      data={ data }
      initialDataValues={ filtersInUrl }
      onApply={ onApply }
      dataTest='status-select'
      isActive={ filtersInUrl.length > 0 }
    />
  );
};

export default StatusFilter;
